var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardList(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1464 7.14638L16.8536 7.85362L14.5 10.2071L13.1464 8.85363L13.8536 8.14637L14.5 8.79288L16.1464 7.14638ZM14.5 12.2929L13.8536 11.6464L13.1464 12.3536L14.5 13.7071L16.8536 11.3536L16.1464 10.6464L14.5 12.2929ZM14.5 15.7929L13.8536 15.1464L13.1464 15.8536L14.5 17.2071L16.8536 14.8536L16.1464 14.1464L14.5 15.7929ZM19 3V22H5V3H8.5V2H15.5V3H19ZM9.5 4H14.5V3H9.5V4ZM18 4H15.5V5H8.5V4H6V21H18V4ZM7 9.5H12V8.5H7V9.5ZM7 13H12V12H7V13ZM7 16.5H12V15.5H7V16.5Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardList);
export default __webpack_public_path__ + "static/media/clipboard-list.7cad7f82c4cc130aeb899a4af8de1f02.svg";
export { ForwardRef as ReactComponent };